
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import { fetchCustomerList } from "./Slice";
import { getCustomerListSelector, loadingCustomerListSelector } from "./Slice";
import CustomerGrid from "./CustomerGrid";

interface SearchGridWidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: SearchGridWidgetProps) => {
  const dispatch = useAppDispatch();

  const customerListLoading = useSelector(loadingCustomerListSelector);
  const customerList = useSelector(getCustomerListSelector);
  const [recentCustomerList, updateRecentCustomerList] = useState([]);

  useEffect(() => {
    dispatch<any>(fetchCustomerList());
  }, []);
  useEffect(() => {}, [customerListLoading]);
  useEffect(() => {
    let newCustomerList = JSON.parse(localStorage.getItem("recentCustomers2"));
    if (newCustomerList == null || newCustomerList == undefined)
      newCustomerList = [];
    updateRecentCustomerList(newCustomerList);
  }, []);

  if (customerListLoading == "pending" || customerListLoading == undefined) {
    return <Spinner text="customer list" />;
  }
    if (customerList == null) {
        return (
            <>
                <br />
                <ErrorMessage
                    text={"No data found,customer list is being update. Please try again soon."}
                    id={props.id}
                    header={props.header}
                />
            </>
        );
    }
  if ( customerList.length === 0) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found,customer list is being update. Please try again soon."}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return (
    //<div style={{padding:"10px"} }>
    //    <h5>Recently selected customers</h5>
    //    <CustomerGrid data={recentCustomerList} recent={true} />
    //    <br/>
    //    <h5>Customer List</h5>
    <CustomerGrid data={customerList} />
    /* </div>*/
  );
};

export default SearchGridWidget;
